<template>
  <Modal size="sm" withoutFooter="true" closeIcon="true" @close="$emit('skip')">
    <template slot="header">
      <h1 class="font-semibold text-3xl text-center my-4">
        Claim Your Exclusive Marketing Territories
      </h1>
    </template>
    <template slot="body">
      <div class="wrapper lg:px-20">
        <div class="price-table mx-auto border border-gray-200 rounded">
          <div class="grid grid-cols-3 p-4">
            <span class="location">Location</span>
            <span class="price">Price</span>
            <button class="red-btn">Actions</button>
          </div>
          
          <template v-if="priceDetails.length > 0">
            <div
              v-for="(row, index) in priceDetails"
              :key="index"
              class="grid grid-cols-3 items-center p-4 border-t border-gray-200"
            >
              
              <span class="location">{{ row.location }}</span>
              <span class="price">{{ row.price | currencyFormat }}</span>
              <button
                @click="$emit('removeLocation', row.location)"
                class="bg-primary text-white mx-auto hover:bg-opacity-75 font-semibold rounded-lg p-2 w-24"
              >
                remove
              </button>
            </div>
          </template>
          <div v-else class="col-span-3 p-4 border-t border-gray-200 text-gray-700">No unpaid locations left</div>
        </div>

        <div class="total font-semibold text-xl text-center mt-10" v-if="priceDetails.length > 0">
          Total: <span>${{ total }}</span>
        </div>

        <section class="mb-16" v-if="priceDetails.length > 0">
          <div class="mt-16 font-semibold">Your Payment Details</div>
          
          <!-- show payment options -->
          <DefaultPaymentSource @selected="cardSelected = true" class="mt-4" />
          

          <!-- description -->
          <div class="mt-4">
            <p class="text-sm">Purchases are for one month and can be cancelled at anytime. Return to this section to add and remove marketing territories. </p>
          </div>

          <!-- buttons -->
          <div class="mt-10">
            <div class="flex flex-col-reverse sm:flex-row justify-between">
              <button
                class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                @click="$emit('back')"
              >
                <span>Cancel</span>
              </button>
              <button
                class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                :disabled="!canSubmit"
                @click="checkout"
              >
                <span v-if="!progressCheckout">Submit</span>
                <Spinner class="mx-auto" v-if="progressCheckout" />
              </button>
            </div>
          </div>
        </section>

        <div class="flex justify-center" v-if="priceDetails.length == 0">
          <button 
            class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-10"
            @click="$emit('close')"
          >Close</button>
        </div>
      </div>
    </template>

  </Modal>
</template>

<script>
import Spinner from "@/components/common/Spinner";
import Api from "@/api/api_v1.0";
import { StripeElements } from "vue-stripe-checkout";
import Modal from "@/components/common/Modal.vue";
import DefaultPaymentSource from "@/components/common/payments/DefaultPaymentSource"


export default {
  name: "CheckoutLocationsModal",
  data() {
    return {
      cardSelected: false,
      progressCheckout: false,
    };
  },

  props: ["total", "priceDetails", "catererId"],

  components: {
    StripeElements,
    Spinner,
    Modal,
    DefaultPaymentSource,
  },

  mounted() {
    const cardTimerIndex = setInterval(() => {
      if (this.$refs.checkout?.card) {

        this.$refs.checkout.card.update({ hidePostalCode: true });
        
        clearInterval(cardTimerIndex);
      }
    }, 1000);
    
  },

  computed: {
    canSubmit() {
      return this.cardSelected;
    }
  },

  methods: {

    checkout() {
      this.progressCheckout = true;
      
      Api.catererCheckoutLocations(this.catererId)
        .then(response => {
          this.progressCheckout = false;
          this.showGlobalSuccessMessage(
            "Your payment is successful!"
          );

          this.$emit('success', true);
        })
        .catch(() => {
          this.progressCheckout = false;
        });
    },
    
  }
};
</script>

<style></style>
